export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10926.3cfc6e1c.jpg";